import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import { Box, Button, Drawer, FormControl, IconButton, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAppDispatch, useAppSelector } from 'app/store';
import { Controller, useForm } from 'react-hook-form';
import { useAddCountryMutation, useEditCountryMutation } from 'features/useCountry/api/useCountryApi';
import { useEffect } from 'react';

type FormDataType = { name: string };

export const CountryCreateWidget = ({
  country,
  setCountry,
  refetch,
}: {
  country: any;
  setCountry: any;
  refetch: any;
}) => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen } = useAppSelector((state) => state.ui);

  const [addCountry] = useAddCountryMutation();
  const [editCountry] = useEditCountryMutation();

  const { control, getValues, setValue } = useForm<FormDataType>({
    defaultValues: { name: '' },
  });

  useEffect(() => {
    if (country) {
      setValue('name', country.name);
    }
  }, [country, setValue]);

  const onSendData = async () => {
    const data =
      country && country.id
        ? await editCountry({ id: country.id, body: getValues() })
        : await addCountry({ body: getValues() });

    if (data) {
      refetch();
      dispatch(setDrawerOpen(false));
      setCountry({});
    }
  };

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => dispatch(setDrawerOpen(false))}
    >
      <DrawerContent style={{ width: '800px' }}>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            {country?.id ? 'Изменить' : 'Добавить'} страну
          </Typography>

          <IconButton
            onClick={() => {
              dispatch(setDrawerOpen(false));
              setCountry({});
            }}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div className="content">
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <FormControl sx={{ width: '100%' }}>
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Название страны"
                    fullWidth
                    sx={{ marginBottom: '24px' }}
                    {...field}
                  />
                )}
              />
            </FormControl>
          </Box>

          <Button
            onClick={onSendData}
            variant="contained"
            sx={{ textTransform: 'none', marginTop: '24px' }}
          >
            {country?.id ? 'Изменить' : 'Добавить'}
          </Button>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
